import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";

export type SavBlockingContextValue = {
  isBlockingEnabled: boolean;
  blockingMinutes: number;
  feedbackMessage: string;
  isBlocked: boolean;
  isUnderage: boolean;
  setIsUnderage: (value: boolean) => void;
};

const defaultValue: SavBlockingContextValue = {
  isBlockingEnabled: false,
  blockingMinutes: 60,
  feedbackMessage: "",
  isBlocked: false,
  isUnderage: false,
  setIsUnderage: () => undefined,
};

const SavBlockingContext = createContext<SavBlockingContextValue>(defaultValue);

export const SavBlockingProvider = ({ value, children }: PropsWithChildren<{ value: SavBlockingContextValue }>) => {
  return <SavBlockingContext.Provider value={value}>{children}</SavBlockingContext.Provider>;
};

export const useSavBlocking = () => useContext(SavBlockingContext);
